<template>
  <div id="app">

    <!-- header title -->
    <j-headful :title="$route.meta.title"/>

    <!-- Preload -->
    <transition name="fade-slow">
      <j-preload v-if="showPreload" />
    </transition>

    <!-- header border -->
    <j-header v-if="showContent" />

    <!-- router -->
    <router-view v-if="showContent"/>

    <!-- notification screen -->
    <j-loading-screen
      v-if="showContent"
      ref="loadingScreen"
      :message="loading_message"/>
    <j-info-screen
      v-if="showContent"
      ref="infoScreen"
      :message="info_message"/>
    <j-problem-screen
      v-if="showContent"
      ref="problemScreen"
      :message="problem_message"
      :code="problem_code"/>
    <j-success-screen
      v-if="showContent"
      ref="successScreen"
      :message="success_message"/>
    <j-toast
      ref="toastScreen"/>

  </div>
</template>

<script>
/* eslint-disable vue/name-property-casing */
import jPreload from '@/components/jPreload';
import jMixNotificationScreen from '@/mixins/components/notification-screen/jMixNotificationScreen';
import jToast from '@/components/toast/jToast';

export default {
  name: 'default',
  components: {
    jToast,
    jPreload,
  },
  mixins: [jMixNotificationScreen],

  data() {
    return {
      showPreload: true,
      showContent: false,
    };
  },
  created() {
    setTimeout(() => {
      this.showPreload = false;
    }, 3000);
    setTimeout(() => {
      this.showContent = true;
    }, 1000);
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/default.vue